// icons
import chevronRight from '@iconify/icons-carbon/direction-straight-right';
import { Box, Button, Container, Paper, Typography } from '@mui/material';
// @mui
import { styled } from '@mui/material/styles';
import staticLoader from '@utils/staticLoader';
import { m } from 'framer-motion';
import NextImage from "next/image";
import NextLink from 'next/link';
// components
import { Iconify } from '../../components';
import { varFade } from '../../components/animate';
// routes
import Routes from '../../routes';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  textAlign: 'center',
  overflow: 'hidden',
  padding: theme.spacing(8, 0),
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    padding: theme.spacing(10, 0, 15, 0),
  },
}));

// ----------------------------------------------------------------------

export default function MissingService() {
  return (
    <RootStyle>
      <Container sx={{ position: 'relative' }}>
        <Paper
          sx={{
            borderRadius: 3,
            p: { md: 10 },
            bgcolor: { xs: 'transparent', md: 'background.neutral' },
          }}
        >
          <Box
            sx={{
              maxWidth: 360,
              mx: { xs: 'auto', md: 'unset' },
            }}
          >
            <m.div variants={varFade().inLeft}>
              <Typography variant="overline" sx={{ color: 'text.disabled' }}>
                Vi hjelper deg
              </Typography>
            </m.div>

            <m.div variants={varFade().inLeft}>
              <Typography variant="h3" sx={{ mt: 2, mb: 3 }}>
                Fant du ikke <br />
                tjenesten du var ute etter?
              </Typography>
            </m.div>

            <m.div variants={varFade().inLeft}>
              <Typography sx={{ color: 'text.secondary' }}>
                Vi ufører alt fra enkle jobber til de mest komplekse og sammensatte løsningene. Bare
                ta kontakt med kundeservice!
              </Typography>
            </m.div>

            <NextLink href={Routes.contact} passHref>
              <Button
                size="large"
                color="inherit"
                variant="outlined"
                endIcon={<Iconify icon={chevronRight} sx={{ width: 16, height: 16 }} />}
                sx={{ mt: 5, display: { xs: 'none', md: 'flex' } }}
              >
                Kontakt oss
              </Button>
            </NextLink>
          </Box>
        </Paper>

        <Box
          sx={{
            top: { md: -40 },
            right: { md: -80 },
            width: { md: 1 / 2 },
            height: { xs: 200, md: 1 },
            my: { xs: 8, md: 0 },
            position: { xs: 'relative', md: 'absolute' },
          }}
        >
          <m.div variants={varFade().inRight}>
            <NextImage
              loader={staticLoader}
              alt="spørsmålstegn illustrasjon"
              src="/static/illustrations/illustration_faqs.svg"
              layout='fill'
            />
          </m.div>
        </Box>

        <m.div variants={varFade().inLeft}>
          <NextLink href={Routes.contact} passHref>
            <Button
              size="large"
              color="inherit"
              variant="outlined"
              endIcon={<Iconify icon={chevronRight} sx={{ width: 16, height: 16 }} />}
              sx={{ display: { md: 'none' } }}
            >
              Kontakt oss
            </Button>
          </NextLink>
        </m.div>
      </Container>
    </RootStyle>
  );
}
